import type { VibeAgentApi } from './components/use-vibe-agent-api'

/**
 * Module-level handle to the ONE mounted useVibeAgent instance.
 *
 * The api context covers the sidebar subtree; callers OUTSIDE it (title-bar
 * "Test with Vibe", future toolbar actions) cannot call useVibeAgent themselves
 * — a second instance would double the mount rehydration and viewer wiring.
 * The chat root registers its instance here; outsiders go through
 * getVibeAgentApi(). The sidebar shell is always mounted (visibility is a CSS
 * width toggle), so the registry is populated before any user can click.
 */

let current: VibeAgentApi | null = null

export const registerVibeAgentApi = (api: VibeAgentApi): (() => void) => {
  current = api
  return () => {
    if (current === api) current = null
  }
}

export const getVibeAgentApi = (): VibeAgentApi | null => current
